import { createFileRoute } from '@tanstack/react-router'

import AuditLogs from '@/features/Admin/AuditLogs'

export const Route = createFileRoute('/_authenticated/admin/audit-logs')({
    component: RouteComponent,
})

function RouteComponent() {
    return <AuditLogs />
}
